import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { submitFAQProgram } from 'Features/Learning/FAQProgram/Utils/FAQProgramUtils';
import { resetState, setField } from 'Features/Learning/FAQProgram/addFAQProgramSlice';
import Swal from 'sweetalert2';

const FAQProgramPost = ({ modal, toggle }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.addFAQProgram)
  const history = useNavigate();

  const handleSuccess = () => {
    dispatch(resetState());
    history(`${process.env.PUBLIC_URL}/faq-program/`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const required = [
      { key: 'question', label: 'Pertanyaan FAQ' },
      { key: 'answer', label: 'Jawaban FAQ' },
    ];

    const missing = required.find(f => {
      const val = data?.[f.key];
      return val === undefined || val === null || String(val).trim() === '';
    });

    if (missing) {
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `${missing.label} tidak boleh kosong.`,
      });
    }

    // pastikan is_show terset (default '1' jika belum dipilih)
    const payload = {
      ...data,
      is_show: data?.is_show === undefined || data?.is_show === null || String(data?.is_show).trim() === '' ? '1' : String(data.is_show)
    };

    // dispatch sama untuk create/update pada implementasi saat ini
    dispatch(submitFAQProgram({ ...payload, successCallback: handleSuccess }));
  };

  // const handleDiscard = (e) => {
  //   e.preventDefault();
  //   dispatch(resetState());
  //   history(`${process.env.PUBLIC_URL}/fAQ-program/`);
  // };

  return (
    <Fragment>
      {/* <Container fluid={true}>
        <Row>
          <Col sm="12">
            {startUpload ? (
              <Col lg="12">
                <div className="loader-box">
                  <Spinner attrSpinner={{ className: 'loader-30' }} />
                </div>
                <H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Sedang proses unggah...'}</H6>
              </Col>
            ) : (
              <Card>
                <CardHeader className='pb-0'><H5>{isUpdate ? '' : 'FAQ Program Baru'}</H5></CardHeader>
                <CardBody className="add-post">
                  <FAQProgramForm gapiInitialized={gapiInitialized} handleLoginAndPickFile={handleLoginAndPickFile} loadingDriveFile={loadingDriveFile} driveFile={driveFile} setDriveFile={setDriveFile} isDropFile={isDropFile} setIsDropFile={setIsDropFile} />

                  <div className="btn-showcase text-end">
                    <Btn attrBtn={{ color: 'primary', type: 'submit', onClick: handleSubmit }}>{Post}</Btn>
                    <Btn attrBtn={{ color: 'light', type: 'reset', onClick: handleDiscard }}>{Discard}</Btn>
                  </div>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </Container> */}
      <Modal isOpen={modal} toggle={toggle} size='md' backdrop="static" keyboard={false} autoFocus>
        <ModalHeader toggle={toggle}>Tambah FAQ</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="question">Pertanyaan FAQ</Label>
              <Input type="text" title="question" id="question" placeholder="Masukkan pertanyaan FAQ" value={data?.question} onChange={(e) => dispatch(setField({ field: 'question', value: e.target.value }))} autoFocus />
            </FormGroup>
            <FormGroup>
              <Label for="answer">Jawaban FAQ</Label>
              <Input type="textarea" title="answer" id="answer" placeholder="Masukkan jawaban FAQ" value={data?.answer} onChange={(e) => dispatch(setField({ field: 'answer', value: e.target.value }))} />
            </FormGroup>
            {/* previous switch replaced with radio buttons */}
            <FormGroup className="mb-3">
              <Label style={{ fontWeight: 'bold' }}>Tampilkan FAQ :</Label>
              <div className="m-checkbox-inline">
                <Label for="faq_true">
                  <Input className="radio_animated" id="faq_true" type="radio" name="is_show" value="1"
                    checked={data.is_show === 1 || data.is_show === '1'}
                    onChange={e => dispatch(setField({ field: 'is_show', value: e.target.value }))}
                  />
                  YA
                </Label>
                <Label for="faq_false">
                  <Input className="radio_animated" id="faq_false" type="radio" name="is_show" value="0"
                    checked={data.is_show === 0 || data.is_show === '0'}
                    onChange={e => dispatch(setField({ field: 'is_show', value: e.target.value }))}
                  />
                  TIDAK
                </Label>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default FAQProgramPost;